import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { ShoppingBag, Menu, X } from "lucide-react";
import { useCart } from "@/context/CartContext";

const LINKS = [
  { to: "/", label: "HOME" },
  { to: "/shop", label: "SHOP" },
  { to: "/show-up", label: "SHOW UP" },
  { to: "/about", label: "ABOUT" },
];

export function Header() {
  const { count, setOpen } = useCart();
  const [menu, setMenu] = useState(false);

  return (
    <header className="sticky top-0 z-40 bg-paper border-b border-ink/15">
      <div className="max-w-6xl mx-auto px-5 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="font-college text-2xl md:text-3xl text-navy leading-none">
          RUNRS
        </Link>

        <nav className="hidden md:flex items-center gap-8" data-testid="nav-desktop">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `font-college text-lg leading-none transition-colors duration-200 ${
                  isActive ? "text-red" : "text-ink hover:text-red"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            data-testid="cart-open-button"
            onClick={() => setOpen(true)}
            className="relative flex items-center gap-2 px-3 py-1.5 bg-paper hover:bg-ink hover:text-paper transition-colors duration-200"
          >
            <ShoppingBag size={18} />
            <span className="font-college text-base leading-none hidden sm:inline">CART</span>
            {count > 0 && (
              <span data-testid="cart-count" className="absolute -top-2 -right-2 bg-red text-paper text-xs font-bold w-5 h-5 flex items-center justify-center rounded-full">
                {count}
              </span>
            )}
          </button>
          <button
            data-testid="mobile-menu-button"
            onClick={() => setMenu((m) => !m)}
            className="md:hidden p-1.5"
            aria-label="Menu"
          >
            {menu ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {menu && (
        <nav className="md:hidden border-t border-ink/15 bg-paper" data-testid="nav-mobile">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              onClick={() => setMenu(false)}
              data-testid={`nav-mobile-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `block font-college text-2xl px-5 py-4 border-b border-ink/20 ${
                  isActive ? "text-red" : "text-ink"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
      )}
    </header>
  );
}
